import { ApiService, Dictionary } from '@ligo/shared/utils';
import { RESOURCES } from '../resources';
import { HostingRequest } from '@ligo/dashboard/store';

export const HostingService = {
  getHostingByTerm(query: Dictionary = {}) {
    return ApiService.get<HostingRequest[]>(RESOURCES.YOUR_HOSTING_REQUEST, {
      ...query
    });
  }
};
